export default "__VITE_ASSET__CpDhFH9R__"